module.exports = __webpack_public_path__ + "static/media/ic-trash-can.77e51f0e.svg";